import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { useLocation } from 'react-router-dom';
import React from "react";

/**
 * Scrolls to the top of the page
 * @param {boolean} alwaysOnRender  Scroll to top on every rerender
 */
import { jsx as _jsx } from "react/jsx-runtime";
var ScrollToTop = /*#__PURE__*/function (_Component) {
  _inherits(ScrollToTop, _Component);
  var _super = _createSuper(ScrollToTop);
  function ScrollToTop() {
    var _this;
    _classCallCheck(this, ScrollToTop);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * Scrolls to the top of the page
     */
    _this.scrollToTop = function () {
      window.scrollTo(0, 0);
    };
    return _this;
  }
  _createClass(ScrollToTop, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        this.scrollToTop();
      } else if (this.props.alwaysOnRender) {
        this.scrollToTop();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.alwaysOnRender) {
        this.scrollToTop();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return ScrollToTop;
}(Component);
ScrollToTop.defaultProps = {
  alwaysOnRender: false
};

// To support legacy class syntax
function withRouter(Child) {
  return function (props) {
    var location = useLocation();
    return /*#__PURE__*/_jsx(Child, _extends({}, props, {
      location: location
    }));
  };
}
export default withRouter(ScrollToTop);